import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import states from 'states-us';
import TextInput from 'web/components/form-elements/TextInput';
import TextArea from 'web/components/form-elements/TextArea';
import NumberInput from 'web/components/form-elements/NumberInput';
import Select from 'web/components/form-elements/Select';
import PhoneNumber from 'web/components/form-elements/PhoneNumber';
import { diverseSpendListFetchApi } from 'redux/actions/register'
import information from "web/assets/images/informationIcon.png";
import { StepOneContainer, ButtonWrapper, FormWrapper } from 'web/pages/account/registration/corporate-Registration-Styled'
import MultiSelect from 'web/components/MultiSelect';
import { Tooltip } from 'reactstrap';
export default ({ setFieldValue, isValid, dirty, props, email, submitCallBack, pageLanguageContents }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  let location = useLocation()
  const [zipCodeError, setZipCodeError] = useState(false);
  const [promoCodeValidate, setPromoCodeValidate] = useState(false);

  const [diverseSpendList, setDiverseSpendList] = useState()

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const [alertType, setAlertType] = useState('');
  const toggleModal = () => setModal(!modal);

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = []

  for (let i = 0; i < territoryStates.length; i++) {
    if (territoryStates[i].name !== 'District Of Columbia') {
      let obj = {
        value: territoryStates[i].name,
        label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
        isoCode: territoryStates[i].abbreviation
      }
      stateArr.push(obj)
    }
  }

  let modeOfContactArray = [{ value: 'Advertisement', label: 'Advertisement' },
  { value: 'Billboards', label: 'Billboards' },
  { value: 'Blue Print Box', label: 'Blue Print Box' },
  { value: 'Conference/Tradeshow', label: 'Conference/Tradeshow' },
  { value: 'Digital Magazine ', label: 'Digital Magazine ' },
  { value: 'Email Marketing', label: 'Email Marketing' },
  { value: 'Google', label: 'Google' },
  { value: 'History with Bettaway', label: 'History with Bettaway' },
  { value: 'Podcast/Interviews', label: 'Podcast/Interviews' },
  { value: 'Radio', label: 'Radio' },
  { value: 'Referral', label: 'Referral' },
  { value: 'Social Media', label: 'Social Media' },
  { value: 'Other', label: 'Other' }]

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.pathname.includes('/registration/')) {
      const pathName = location.pathname.replace('/registration/', '')
      if (pathName.includes('/')) {
        setFieldValue('email', pathName.split('/')[0])
        setFieldValue('promoCodeInput', pathName.split('/')[1])
      } else {
        setFieldValue('promoCodeInput', pathName)
      }
    }
    const queryParams = new URLSearchParams(location.search)
    const queryPromoCode = queryParams.get("utm_content")
    if (queryPromoCode) setFieldValue('promoCodeInput', queryPromoCode)

    fetchDiverseSpendList()
  }, [])

  const fetchDiverseSpendList = async () => {
    let response
    response = await dispatch(diverseSpendListFetchApi());
    if (response.status === 'SUCCESS' && response.payload?.length > 0) {
      let deiverseAllListTemp = response.payload.map(data => ({ label: data.category, value: data.category, description: data.description, id: data.id }))
      setDiverseSpendList(deiverseAllListTemp)
      setFieldValue('diverseSpendSelectedList', [])
    } else {
      setDiverseSpendList([])
      setFieldValue('diverseSpendSelectedList', [])
    }
  }

  localStorage.setItem('creditCardNumber', '');
  localStorage.setItem('subscriptionCardNumber', '');
  localStorage.setItem('creditCardName', '')
  localStorage.setItem('debitCardNumber', '');
  localStorage.setItem('buyerDebitCardNumber', '');
  localStorage.setItem('sellerDebitCardNumber', '');
  localStorage.getItem('debitCardName', '');
  localStorage.getItem('debitCardNumber', '');
  localStorage.getItem('debiCardPaymentMethod', '');
  localStorage.getItem('paymentSubscription', '');
  const [tooltipOpenOne, setTooltipOpenOne] = useState(false);
  const iIcon = (infoTxt) => {
    return <>
      <img
        id="TooltipOne"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipOpenOne}
        target="TooltipOne"
        toggle={() =>
          setTooltipOpenOne(!tooltipOpenOne)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  const [tooltipPasswordIcon, setTooltipPasswordIcon] = useState(false);
  const passwordIcon = (infoTxt) => {
    return <>
      <img
        id="PasswordIcon"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
          cursor: 'pointer'
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipPasswordIcon}
        target="PasswordIcon"
        toggle={() =>
          setTooltipPasswordIcon(!tooltipPasswordIcon)
        }
      >
        {/* {infoTxt} */}
        <span style={{ 'Display': 'block', fontSize: '14px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>Password must have:</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least 8 characters.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one capital letter.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one lowercase letter.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one special characters.</span>
        <span style={{ 'Display': 'block', fontSize: '12px', whiteSpace: "nowrap", display: 'flex', justifyContent: 'flex-start' }}>At least one number</span>
      </Tooltip>
    </>
  }

  const [tooltipState, setTooltipState] = useState(false);
  const [tooltipTitleState, setTooltipTitleState] = useState("");
  const iIconInfoToolTip = (infoTitle, infoTxt) => {
    return <>
      <img
        id={infoTitle}
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipState && (tooltipTitleState === infoTitle)}
        target={infoTitle}
        toggle={() => {
          setTooltipState(!tooltipState)
          setTooltipTitleState(tooltipTitleState === "" ? infoTitle : "")
        }
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  const zipCodeFunction = async (value) => {
    setZipCodeError(false)
    let response = '';
    if (value.length === 5) {
      response = await dispatch(checkIsZipCode(value))
      if (response.success) {
        setFieldValue('locationZip', response?.data?.zipCode)
        setFieldValue('locationST', response?.data?.state)
        setFieldValue('locationCity', response?.data?.city)
      } else {
        if (response?.data?.error?.message === 'Invalid Zip Code.') {
          setFieldValue('locationST', "")
          setFieldValue('locationCity', "")
          setZipCodeError(true)
        } else if (response.error?.message === "Invalid token" || response.message === 'Request failed with status code 401') {
          history.push('/sign-in')
          window.location.reload(false);
        } else {

        }
      }
    } else {
      setFieldValue('locationST', "")
      setFieldValue('locationCity', "")
    }
  }

  return (
    <>
      <StepOneContainer>
        <FormWrapper>
          <div className="row mx-0">
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[0]?.Name}<span className="star">*</span>
                </p>
              </div>
              <div>
                <TextInput
                  name="name"
                  inputType="text"
                />
              </div>
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[2]?.Email}<span className="star">*</span>
                </p>
              </div>
              <div>
                <TextInput
                  name="email"
                  inputType=""
                  maxLength={100}
                  disabled={email ? true : false}
                />
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[4]?.Password}<span className="star">*</span>
                  {passwordIcon(pageLanguageContents?.ErrorValidations[3]?.MinEight)}
                </p>
              </div>
              <div>
                <TextInput
                  name="password"
                  type="password"
                  inputType=""
                />
              </div>
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[6]?.ConfimPwd}<span className="star">*</span>
                </p>
              </div>
              <div>
                <TextInput
                  name="confirmPassword"
                  type="password"
                  inputType=""
                />
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-sm-12 col-xs-12">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[8]?.Company}<span className="star">*</span>
                </p>
              </div>
              <div>
                <TextInput name="companyName" inputType="companyText" />
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>DBA</p>
              </div>
              <div>
                <TextInput name="DBAName" inputType="companyText" />
              </div>
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>{pageLanguageContents?.Arrow1_Basic[10]?.Phone}<span className="star">*</span>
                  {iIcon(pageLanguageContents?.Arrow1_Basic[20]?.Phone_Info)}</p>
              </div>
              <div>
                <PhoneNumber name="smsPhNumber" inputType="addressText" />
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[11]?.Add1}<span className="star">*</span>
                </p>
              </div>
              <div>
                <TextInput name="line1" inputType="addressText" />
              </div>
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>{pageLanguageContents?.Arrow1_Basic[13]?.Add2}</p>
              </div>
              <div>
                <TextInput name="line2" inputType="addressText" />
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="col-sm-4 col-xs-12 select-height">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[14]?.City}<span className="star">*</span>
                </p>
              </div>
              <div>
                <TextInput name="locationCity" inputType="city" onChangeHandler={(value) => {
                  setFieldValue('locationZip', "")
                }} />
              </div>
            </div>
            <div className="col-sm-4 col-xs-12 select-height">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[16]?.State}<span className="star">*</span>
                </p>
              </div>
              <div>
                <TextInput name="locationST" disabled />
              </div>
            </div>
            <div className="col-sm-4 col-xs-12 select-height">
              <div className="mb-2 label-color">
                <p>
                  {pageLanguageContents?.Arrow1_Basic[17]?.Zip}<span className="star">*</span>
                </p>
              </div>
              <div>
                <NumberInput name="locationZip" maxLength="5" onChangeHandler={(value) => {
                  zipCodeFunction(value)
                }} />
                {zipCodeError && <h6 style={{ marginTop: '-15px', fontSize: '12px', color: '#ef5657' }}>Invalid Zip Code.</h6>}
              </div>
            </div>
          </div>

          <div className="row mx-0">
            <div className='col-sm-12 col-xs-12'>
              <div className='label-color' >
                <p style={{ color: 'black' }}>{pageLanguageContents?.Arrow2_Account[23]?.URL}</p>
              </div>
              <div>
                <TextInput name='businessUrl' placeholder='https://'
                />
              </div>
            </div>
          </div>

          <div className="row mx-0">
            <div className="col-12">
              <div className="my-2 label-color">
                <p>{pageLanguageContents?.Arrow2_Account[25]?.Description}</p>
              </div>
              <div className="textAreaClass">
                <TextArea
                  name="businessDesc"
                  inputType="textAndNumber"
                  placeholder=""
                />
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <div style={{ position: 'relative' }}>
              <div className="mb-2 ml-3 label-color">
                <p style={{ whiteSpace: 'nowrap' }}>
                  Diverse Spend Tracking
                  {iIconInfoToolTip('diverseTracking', 'If you are a certified diverse business (owned and operated by at least 51%) please select the appropriate diverse category.')}
                </p>
              </div>
              <div className='col-12 diverse-spend-multiselect-style'>
                <MultiSelect
                  name="diverseSpendSelectedList"
                  data={diverseSpendList}
                  multiSelectVal={props.values?.diverseSpendSelectedList}
                  defaultValueArr={props.values?.diverseSpendSelectedList}
                  placeholder='Select...'
                  isSearchable={true}
                  onChangeHandler={(data) => {
                    setFieldValue('diverseSpendSelectedList', data)
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row mx-0 mb-2">
            <div className="col-sm-6 col-xs-12">
              <div className="mb-2 label-color">
                <p>
                  How Did You Hear About Us?<span className="star">*</span>
                </p>
              </div>
              <div className="mb-2">
                <Select
                  name="modeOfContact"
                  data={modeOfContactArray}
                  searchable={true}
                  onChangeHandler={() => { }}
                />
              </div>
            </div>
          </div>
          {props.values.modeOfContact === 'Other' &&
            <div className="row mx-0">
              <div className="col-sm-8 col-xs-12">
                <div>
                  <TextArea
                    name='modeOfContactOther'
                    maxLength='200'
                    showErrorMessages={true}
                  />
                </div>
              </div>
            </div>
          }

          <ButtonWrapper>
            <Button
              type="app-green-button submitBtn step-1"
              disabled={!(isValid && dirty)}
              handleClick={() => {
                submitCallBack(promoCodeValidate)
              }}
            >
              {pageLanguageContents?.Arrow1_Basic[19]?.Button}
            </Button>
          </ButtonWrapper>

        </FormWrapper>
      </StepOneContainer>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => setFieldValue("promoCodeChk", false)}
      />
    </>
  );
};
